import React, { useState } from 'react';
import { useGetBulkPushes } from '../../../libs/pm';
import type { IBulkPushMessage } from '../../../libs/pm';
import Card, { CardBlock } from '../../organisms/card';
import { LoadingBlock } from '../../organisms/loading/progress';
import Pagination from '../../organisms/pagination';
import PMTemplateCard from '../../organisms/pm/card';
import Table from '../../organisms/table';

import { Column } from 'react-table';
import { FormatDateTime } from '../../../libs/time';
import { useApps } from '../../../contexts/apps';
import { FormatNumber } from '../../../libs/format';

const VIEW_LIMIT = 5;

const ViewBulkPM = (): JSX.Element => {
  const { apps } = useApps().data || {};
  const [page, setPage] = useState(1);
  const {
    isLoading,
    bulks: bulkMessages,
    total
  } = useGetBulkPushes({
    page: page - 1,
    limit: VIEW_LIMIT
  });

  if (isLoading) {
    return (
      <CardBlock>
        <LoadingBlock />
      </CardBlock>
    );
  }

  if (!bulkMessages || !bulkMessages.length) {
    return (
      <Card className="mb-6">
        <h3>No Bulk Push Messages</h3>
        <p>
          No bulk messages can be found for this account. Please use the "New
          Push Message" tab to send out a bulk push message.
        </p>
      </Card>
    );
  }

  const columns: Column<IBulkPushMessage>[] = [
    {
      accessor: 'createdAt',
      Header: 'Sent On',
      Cell: ({ value }) => {
        return <span>{FormatDateTime(value)}</span>;
      }
    },
    {
      id: 'email',
      Header: 'Sent By',
      Cell: ({ row: { original } }) => {
        const bulkPM: IBulkPushMessage = original;
        let value = 'Unknown';
        if (bulkPM.user && bulkPM.user.email) {
          value = bulkPM.user.email;
        }
        return <span className="break-anywhere">{value}</span>;
      }
    },
    {
      accessor: 'template',
      Header: 'Template',
      Cell: ({ value }) => {
        return <PMTemplateCard template={value} apps={apps} />;
      }
    },
    {
      accessor: '_numMessagesSent',
      Header: 'Number Sent',
      Cell: ({ value }) => {
        return <span>{FormatNumber(value)}</span>;
      }
    }
  ];

  return (
    <React.Fragment>
      <Card className="pa-0">
        <Table<IBulkPushMessage> data={bulkMessages || []} columns={columns} />
      </Card>
      <div className="mt-6">
        <Pagination
          page={page}
          total={total}
          limit={VIEW_LIMIT}
          onPageChange={setPage}
        />
      </div>
    </React.Fragment>
  );
};

export default ViewBulkPM;
